import { useState } from "react";

export default function AccordionLists({ accordionData }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <section className="py-10 lg:py-36">
      <div className="container">
        <h4 className="text-4xl text-center relative block text-black font-anton underline decoration-4 lg:decoration-8 underline-offset-8 decoration-primary-200 lg:text-5xl">
          Frequently Asked Questions
        </h4>
        <ul className="grid grid-cols-1 mt-11 lg:gap-6 lg:grid-cols-2 lg:mt-32">
          {accordionData.map((item, index) => (
            <li key={index} className="p-5 lg:p-6">
              <button
                type="button"
                className="w-full text-left bg-white focus:outline-none flex justify-between items-center"
                onClick={() => setIsOpen(isOpen === index ? null : index)}
              >
                <span className="text-base font-bold text-black lg:text-xl">
                  {item.title}
                </span>
                <div className="flex-shrink-0">
                  {isOpen === index ? (
                    <svg
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.7485 11.4156H5.90128C5.56483 11.4156 5.28583 11.1366 5.28583 10.8001C5.28583 10.4637 5.56483 10.1847 5.90128 10.1847H15.7485C16.0849 10.1847 16.364 10.4637 16.364 10.8001C16.364 11.1366 16.0849 11.4156 15.7485 11.4156Z"
                        fill="#151318"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.7486 11.132H5.90134C5.56489 11.132 5.28589 10.853 5.28589 10.5166C5.28589 10.1801 5.56489 9.90112 5.90134 9.90112H15.7486C16.085 9.90112 16.364 10.1801 16.364 10.5166C16.364 10.853 16.085 11.132 15.7486 11.132Z"
                        fill="#438797"
                      />
                      <path
                        d="M10.8249 16.0557C10.4885 16.0557 10.2095 15.7767 10.2095 15.4402V5.59299C10.2095 5.25654 10.4885 4.97754 10.8249 4.97754C11.1614 4.97754 11.4404 5.25654 11.4404 5.59299V15.4402C11.4404 15.7767 11.1614 16.0557 10.8249 16.0557Z"
                        fill="#438797"
                      />
                    </svg>
                  )}
                </div>
              </button>
              <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  isOpen === index ? "pt-3 max-h-96" : "pt-0 max-h-0"
                }`}
              >
                <div className="bg-white">
                  <p className="text-sm lg:text-base font-medium text-gray-100">
                    {item.content}
                  </p>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
